var _style, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconLoader(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#008C78;}\n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_xD83D__xDD39_-Loading"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    className: "st0",
    d: "M0,10C0,4.5,4.5,0,10,0s10,4.5,10,10h-4l0,0c0-3.3-2.7-6-6-6s-6,2.7-6,6s2.7,6,6,6v4 C4.5,20,0,15.5,0,10z"
  }))));
}

export default "data:image/svg+xml,export default 'data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIGlkPSJMYXllcl8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCIKCXZpZXdCb3g9IjAgMCAyMCAyMCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMjAgMjA7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KCTxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+CgkJLnN0MHtmaWxsLXJ1bGU6ZXZlbm9kZDtjbGlwLXJ1bGU6ZXZlbm9kZDtmaWxsOiMwMDhDNzg7fQoJPC9zdHlsZT4KCTxnIGlkPSJfeEQ4M0RfX3hERDM5Xy1Mb2FkaW5nIj4KCQk8cGF0aCBpZD0iQ29tYmluZWQtU2hhcGUiIGNsYXNzPSJzdDAiIGQ9Ik0wLDEwQzAsNC41LDQuNSwwLDEwLDBzMTAsNC41LDEwLDEwaC00bDAsMGMwLTMuMy0yLjctNi02LTZzLTYsMi43LTYsNnMyLjcsNiw2LDZ2NAoJCQlDNC41LDIwLDAsMTUuNSwwLDEweiIvPgoJPC9nPgo8L3N2Zz4K'";
export { SvgIconLoader as ReactComponent };